// extracted by mini-css-extract-plugin
module.exports = {"block":"block--1kvYS","divider":"divider--ZWwTQ","button":"button--1sh6I"};
    if(module.hot) {
      // 1637785528067
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  